import { FC } from 'react';
import classNames from 'classnames';
import {
    FontAwesomeIcon,
    FontAwesomeIconProps
} from '@fortawesome/react-fontawesome';
import {
    faTwitter,
    faDiscord,
    faGithub,
    faMedium
} from '@fortawesome/free-brands-svg-icons';

export interface SocialBarProps extends Pick<FontAwesomeIconProps, 'size'> {
    className?: string;
}

export const SocialBar: FC<SocialBarProps> = ({ className, size = '2x' }) => (
    <ul className={classNames('list-inline', 'm-0', className)}>
        <li className="list-inline-item me-3">
            <a href="https://twitter.com/DelandLabs" target="_blank" rel="noreferrer" className="text-secondary"><FontAwesomeIcon size={size} icon={faTwitter} /></a>
        </li>
        <li className="list-inline-item me-3">
            <a href="https://github.com/Deland-Labs" target="_blank" rel="noreferrer" className="text-secondary"><FontAwesomeIcon size={size} icon={faGithub} /></a>
        </li>
        <li className="list-inline-item me-3">
            <a href="https://medium.com/@DelandLabs" target="_blank" rel="noreferrer" className="text-secondary"><FontAwesomeIcon size={size} icon={faMedium} /></a>
        </li>
        <li className="list-inline-item me-3">
            <a href="https://discord.gg/CdzzUaFUXq" target="_blank" rel="noreferrer" className="text-secondary"><FontAwesomeIcon size={size} icon={faDiscord} /></a>
        </li>
    </ul>
);
